import * as React from 'react';
import './Preloader.scss';
import { Svg } from '@src/assets/svg/Svg';

export interface IProps {
    darkBackground?: boolean;
    isFixed?: boolean;
}

export interface IFunctions {}

export type IAllProps = IProps & IFunctions;

export const Preloader: React.SFC<IAllProps> = ({darkBackground, isFixed}) =>
    <span
        className={`Preloader-wrap ${darkBackground && 'dark-background'} ${isFixed && 'is-fixed'}`}
        dangerouslySetInnerHTML={{ __html: Svg.preloaderLogo(90) }}
    />;

export default Preloader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/preloader/Preloader.tsx